import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-techgeek-container',
  imports: [CommonModule,RouterModule],
  standalone:true,
  templateUrl: './techgeek-container.component.html',
  styleUrl: './techgeek-container.component.scss'
})
export class TechgeekContainerComponent {

}
